import React, { useEffect, useState } from "react";
import styles from "./RecommendationBook.module.css";
import { Cover } from "../../Cover/Cover";
import { Author } from "../../Author/Author";
import { Link } from "react-router-dom";
import { getUsermediaByID } from "../../../api/Api";

export const RecommendationBook = (props) => {

    // props:
    // 
    // recItem - object containing recommendation book information

    // ----------------------------------------------------- STATE AND HOOKS
    let token = localStorage.getItem("token");
    const [mediaItem, setMediaItem] = useState(null);

    useEffect(() => {
        if (props.recItem !== undefined && props.recItem?.recommendedMedia !== null) {
            fetch_media();
        }
    },[])
    
    
    let mediaPath = `/${mediaItem?.type}/` + mediaItem?.mediaid;

    console.log(props.recItem)

    // ----------------------------------------------------- PRE-RENDER

    async function fetch_media() {
        if (props.recItem?.recommendedMedia == null) return;

        await getUsermediaByID(props.recItem?.recommendedMedia, token)
            .then((media) => {
                setMediaItem(media);
            })
            .catch((error) => {
                console.log(error, "Failed to find media for recommendation book")
            })
    }

    // ----------------------------------------------------- RENDER

    if (mediaItem !== null) {
        return (
            <section className={styles.container}>
                <Cover mediaItem={mediaItem} size={window.screen.width > 500 ? "L" : "S"} loc={"bookRec:" + mediaItem?.mediaid} />
                <div className={styles.bookInfoAndNote}>
                    <Link to={mediaPath} className={styles.link}><h1 className={styles.bookTitle}>{mediaItem?.title}</h1></Link>
                    <Author authorsList={mediaItem?.creators} size={1} link={true} />
                    <div className={styles.note}>{props.recItem?.note}</div>
                </div>

            </section>
        )
    }
}